import { combineReducers } from 'redux';
import app from './app';
/* @ts-expect-error module is untyped */

import auth from './auth';
import callouts from '../slices/callouts/calloutsSlice';
/* @ts-expect-error module is untyped */

import certifications from './certifications';
import collections from '../slices/collections/collectionsSlice';
/* @ts-expect-error module is untyped */

import notifications from 'ReduxMessenger/reducers/Notifications';
/* @ts-expect-error module is untyped */

import reviews from './reviews';
/* @ts-expect-error module is untyped */

import storefront from './storefront';
const rootReducer = combineReducers({
  app,
  auth,
  callouts,
  certifications,
  collections,
  notifications,
  reviews,
  storefront
});
export default rootReducer;